import React, { useState, useEffect } from "react";
import { getAI, getGenerativeModel, GoogleAIBackend } from "firebase/ai";
import { app } from "../config/firebase";

const QuestionGenerator = ({ role, experience, setQuestions }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [localQuestions, setLocalQuestions] = useState([]);

  const generateQuestions = async () => {
    setLoading(true);
    setError(null);

    try {
      const ai = getAI(app, { backend: new GoogleAIBackend() });
      const model = getGenerativeModel(ai, { model: "gemini-1.5-flash" });

      const prompt = `Generate a detailed mock interview consisting of enough questions to cover approximately 1.5 hours for a candidate with the following details:\n\nRole: ${role}\nExperience: ${experience} years.\n\nEnsure the questions are diverse, cover technical, behavioral, and situational aspects, and are appropriate for the candidate's level.`;

      const response = await model.generateContent(prompt);
      const text = await response.response.text();

      const questions = text
        .split(/\n+/)
        .map((q) => q.replace(/^\d+\.\s*/, "").trim())
        .filter((q) => q.length > 10);

      const finalQuestions = questions;

      setLocalQuestions(finalQuestions);
      setQuestions(finalQuestions);
    } catch (err) {
      setError("❌ Failed to generate questions. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (role && experience) {
      generateQuestions();
    }
  }, [role, experience]);

  return (
    <div className="text-center p-4">
      {loading && (
        <div className="text-indigo-600 font-medium animate-pulse">
          Generating questions...
        </div>
      )}

      {error && <p className="text-red-600 mt-2">{error}</p>}

      {!loading && !error && localQuestions.length > 0 && (
        <div className="text-left mt-4 space-y-2">
          <p className="text-gray-700 font-semibold">✅ Questions generated:</p>
          <ul className="list-disc ml-5 text-sm text-gray-800">
            {localQuestions.map((q, index) => (
              <li key={index}>{q}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default QuestionGenerator;
